import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { WorkorderService } from '../services/workorder.service';
import { CustomerService } from '../services/customer.service';
import { UserService } from '../services/user.service';
import { Customer } from '../models/customer';
import { Router } from '@angular/router';
import { LocationsearchService } from '../services/locationsearch.service';

@Component({
  selector: 'app-merge-customer',
  templateUrl: './merge-customer.component.html',
  styleUrls: ['./merge-customer.component.scss']
})
export class MergeCustomerComponent implements OnInit {

  className: string = '';
  loadMergeCustomer: boolean = true;
  displayedColumns: string[] = ['Name', 'Address', 'AccountNum', 'PrimaryPhone', 'MatchBy'];
  statusData: any = [];
  dataSource = new MatTableDataSource<any>();
  selectedRow: any = null;



  constructor(public dialogRef: MatDialogRef<MergeCustomerComponent>,
    public customerService: CustomerService,
    public userService: UserService,
    private router: Router, private locationSearchService: LocationsearchService,
  ) {

  }

  ngOnInit(): void {
    this.loadMergeCustomer = true;

    const personCompanyId = localStorage.getItem('personcompanyid');
    this.customerService.matchCustomer(personCompanyId).subscribe({
      next: (response) => {
        //console.log('Response:', response);
        this.statusData = response.MASTERFILEDATA;
        this.dataSource = new MatTableDataSource(this.statusData);
        this.loadMergeCustomer = false;
        //console.log('Data:', this.dataSource);
      },
      error: (err) => {
        console.error('Error fetching customer match:', err);
      }
    });


  }


  onRowClicked(row: any) {
    if (this.selectedRow == row) {
      this.selectedRow = null;
    } else {
      this.selectedRow = row;
    }
  }


  confirmSelection() {
    if (this.selectedRow) {
      const payload = {
        officeId: localStorage.getItem('officeId'),
        masterId: this.selectedRow.MasterPersoncompany,
        onlineId: localStorage.getItem('personcompanyid'),
        userId: this.userService.dbBBCSId,
        keyValue: this.selectedRow.KeyColumn
      };

      this.customerService.mergeCustomer(payload).subscribe({
        next: (Response) => {
          //console.log('Response: ',Response);
          const isSuccess = Response.Action === 0; 
          Swal.fire({
            title: isSuccess ? 'Success' : 'Error',
            text: Response.Message,
            icon: isSuccess ? 'success' : 'error',
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed && isSuccess) {                   
              this.customerService.getCustomerById(Response.Personcompany).subscribe(newCust => {
                this.navToDetail(newCust);
              });         
            }
          });


        },
        error: (err) => {

          Swal.fire({
            title: 'Technical Error',
            text: 'An unexpected error occurred while merging.',
            icon: 'error'
          });
          console.error('Error merging customer:', err);
        }
      }); 
    }
  }

  navToDetail(cust: any) {
    const tempcust: Customer = new Customer();
    tempcust.setUpFromWS(cust);
    this.customerService.currentCustomer = tempcust;
    this.customerService.storedCustomers(tempcust);
    this.router.navigate(['/detail']);
  }


  closedialog() {
    this.dialogRef.close();
  }
}
